import request from '../base-service';
import { InternalAxiosRequestConfig } from 'axios';

export interface BudgetRequest {
  id: string;
  idGiaiDoan?: string;
  idPhuTrach?: string;
  parentID?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
  site?: string;
  ignoreID?: string;
  departmentID?: string;
  positionID?: string;
  roleGroupID?: string;
  trangThaiLamViec?: string;
  year?: number;
  guid?: string;
  hasGuid?: boolean;
  hasBaoCao?: boolean;
  listID?: string[];
  isContinue?: boolean;
  vitris?: number[];
  isBoKPI?: boolean;
  query?: string;
}

export interface BudgetPayload {
  congViec: {
    id: string;
    site: string;
  };
  listNganSachs: {
    id: string;
    site: string;
    kyBaoCao: string;
    nganSachThucTe: number;
    ghiChu: string;
    soTaiLieu: number;
  }[];
  listNganSachChilds: {
    id: string;
    parentId?: string;
    site?: string;
    kyBaoCao?: string;
    nganSachThucTe?: number;
    ghiChu?: string;
    soTaiLieu?: number;
  }[];
}

export const budgetsApi = {
  getList: (payload: BudgetRequest) => {
    return request.post(`/v1/baocaocongviec/getngansach`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },

  delete: (payload: BudgetRequest) => {
    return request.post(`/v1/baocaocongviec/xoangansach`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },

  save: (payload: BudgetPayload) => {
    return request.post(`/v1/baocaocongviec/savebaocaongansach`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
};
